<template>
    <div class="px-2 py-6 shadow-xs rounded">
        <div class="d-flex align-items-center justify-content-center">
            <i :class=icon class="mr-3"></i>
            <h2 class="text-center card-title mb-0">{{ title }}</h2>
        </div>

        <div v-if="series[0].total > 0">
            <p class="text-primary text-center mb-8 mt-2 text-3xl">{{ series[0].total }}</p>
            <line-chart :series="series"/>
        </div>
        <p v-else class="text-center text-xl mt-4 mb-10">{{ __('statistics.impressions_empty_for_date') }}</p>

    </div>
</template>

<script>
import LineChart from '@pages/Stats/Widgets/LineChart.vue';

export default {
    name: 'LineChartWrapper',
    components: {LineChart},

    props: {
        series: [Array, Object],
        title: String,
        icon: String,
    },
};
</script>
